<div class="tooltip-content">
    <ng-content></ng-content>
</div>
<div class="arrow"></div>
